"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Signature = function (_Component) {
  (0, _inherits3.default)(Signature, _Component);

  function Signature(props) {
    (0, _classCallCheck3.default)(this, Signature);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Signature.__proto__ || (0, _getPrototypeOf2.default)(Signature)).call(this, props));

    _this.state = {
      activeIndex: 0,
      intervalId: null,
      // this is only for CSS on mobile
      hideDetails: props.hideDetails
    };
    return _this;
  }

  /* eslint react/no-did-mount-set-state: "off" */


  (0, _createClass3.default)(Signature, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var intervalId = setInterval(this.timer.bind(this), 5000);
      // store intervalId in the state so it can be accessed later:
      this.setState({ intervalId: intervalId });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // use intervalId from the state to clear the interval
      clearInterval(this.state.intervalId);
    }
  }, {
    key: "timer",
    value: function timer() {
      // setState method is used to update the state
      this.setState({
        activeIndex: this.state.activeIndex < this.props.items.length - 1 ? this.state.activeIndex + 1 : 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          items = _props.items;
      var _state = this.state,
          activeIndex = _state.activeIndex,
          hideDetails = _state.hideDetails;


      return _react2.default.createElement(
        "div",
        { className: "area-max" },
        _react2.default.createElement(
          "div",
          { className: "nocontainer featureHeroTop" },
          _react2.default.createElement(
            "div",
            { className: "content" },
            _react2.default.createElement(
              "div",
              { className: "hero" },
              _react2.default.createElement(
                "div",
                {
                  className: "hero-media",
                  style: {
                    overflow: 'visible'
                  }
                },
                items.map(function (item, index) {
                  return _react2.default.createElement("div", {
                    key: item.imageWideUrl,
                    className: "hero-background",
                    style: {
                      backgroundImage: "url(" + item.imageWideUrl + ")",
                      position: 'absolute',
                      top: 0,
                      opacity: index !== activeIndex ? 0 : 1,
                      transition: 'opacity 2s'
                    }
                  });
                }),
                _react2.default.createElement(
                  "div",
                  { className: "hero-search " + (hideDetails ? 'hide-details' : 'show-details') },
                  _react2.default.createElement(
                    "h2",
                    null,
                    i18n.top.searchAndSave
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "full-width-box hotel-list-search" },
                    _react2.default.createElement(
                      "div",
                      {
                        className: "fluid-searchform",
                        onFocusCapture: function onFocusCapture() {
                          _this2.setState({ hideDetails: false });
                        }
                      },
                      this.props.children
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Signature;
}(_react.Component); // Signature

Signature.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired,
  hideDetails: _react.PropTypes.bool,
  children: _react.PropTypes.element
};

exports.default = Signature;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/Signature.js
// module id = 581
// module chunks = 0